module.exports = __webpack_public_path__ + "img/alipay.7ac9f760.svg";